import ListicleOverview from './ListicleOverview'

const ROUTES = [
  ListicleOverview
]

export default ROUTES
